import React from 'react';
import './SolutionPop.less'
interface Props {
  closePop?: (nav: string) => void
}

const SolutionPop: React.FC<Props> = ({ closePop }) => {
  const linkHandle = (type: string) => {
    closePop?.('solution/'+type)
  }
  return (
    <div className='product_tooltips'>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
      <div className='product_item'
             onClick={() => {
               linkHandle('overseas')
             }}
        >
          <div className='product_item_icon industry_icon7'></div>
          <div>
            <div className='product_item_title'>出海业务</div>
            <div className='product_item_desc'>海外市场 | 人群洞察 | 市场进入</div>
            <div className='product_item_desc'>品牌本地化 | 口碑跟踪</div>
          </div>
        </div>
        <div className='product_item'
             onClick={() => {
               linkHandle('consumerGoods')
             }}
        >
          <div className='product_item_icon xiaofeipin'></div>
          <div>
            <div className='product_item_title'>消费品</div>
            <div className='product_item_desc'>机会挖掘 | 产品创新 | 渠道研究</div>
            <div className='product_item_desc'>品牌与广告研究 | 消费者研究</div>
          </div>
        </div>
      </div>
      <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 16, marginTop: 16}}>
      <div className='product_item'
             onClick={() => {
               linkHandle('finance')
             }}
        >
          <div className='product_item_icon industry_icon1'></div>
          <div>
            <div className='product_item_title'>金融行业</div>
            <div className='product_item_desc'>银行｜互联网金融｜保险｜证券</div>
          </div>
        </div>
        <div className='product_item'
             onClick={() => {
               linkHandle('advertise')
             }}
        >
          <div className='product_item_icon industry_icon4'></div>
          <div>
            <div className='product_item_title'>广告监测</div>
            <div className='product_item_desc'>投放执行｜监播与效果评估</div>
            <div className='product_item_desc'>投放计划｜策略优化</div>
          </div>
        </div>
      </div>
      <div style={{display: 'flex', justifyContent: 'space-between', marginBottom: 16, marginTop: 16}}>

      <div className='product_item'
             onClick={() => {
               linkHandle('property')
             }}
        >
          <div className='product_item_icon industry_icon2'></div>
          <div>
            <div className='product_item_title'>物业地产</div>
            <div className='product_item_desc'>满意度数字化 | 增值业务创新</div>
          </div>
        </div>

      </div>

      <div className='product_item_special'
           onClick={() => {
             linkHandle('publicAffair')
           }}
      >
        <div className='product_item_icon industry_icon3'></div>
        <div>
          <div className='product_item_title'>数字政务</div>
          <div className='product_item_special_desc'>
            <span>全国经济/人口/风险普查｜农业农村｜知识产权｜文旅体育｜食品安全</span>
            <span>营商环境｜民政人社</span>
          </div>
        </div>
      </div>




    </div>
  );
};

export default SolutionPop;

